import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Pill } from './css';

const TONES = {
  queued: { color: '#4b286d', background: '#f2eef6', label: 'Queued' },
  running: { color: '#00437d', background: '#e5eff8', label: 'Running' },
  passed: { color: '#13632e', background: '#e6f3ea', label: 'Passed' },
  failed: { color: '#772525', background: '#fbeaea', label: 'Failed' },
  cancelled: { color: '#5a5a5a', background: '#efefef', label: 'Cancelled' },
  timed_out: { color: '#8a5a00', background: '#fdf3e3', label: 'Timed out' },
  dispatch_failed: { color: '#8a5a00', background: '#fdf3e3', label: 'Could not start' }
};

const formatElapsed = (ms) => {
  const seconds = Math.max(0, Math.round(ms / 1000));
  return `${Math.floor(seconds / 60)}m ${String(seconds % 60).padStart(2, '0')}s`;
};

const StatusPill = ({ status, since, durationMs }) => {
  const [now, setNow] = useState(Date.now());
  const isLive = status === 'queued' || status === 'running';

  useEffect(() => {
    if (!isLive) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [isLive]);

  const tone = TONES[status] || TONES.queued;

  let suffix = '';
  if (isLive && since) suffix = ` · ${formatElapsed(now - new Date(since).getTime())}`;
  if (!isLive && durationMs) suffix = ` · ${formatElapsed(durationMs)}`;

  return (
    <Pill color={tone.color} background={tone.background} aria-live="polite">
      {`${tone.label}${suffix}`}
    </Pill>
  );
};

StatusPill.propTypes = {
  status: PropTypes.string.isRequired,
  since: PropTypes.string,
  durationMs: PropTypes.number
};

StatusPill.defaultProps = {
  since: null,
  durationMs: null
};

export default StatusPill;
